<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="pV"></a>Dedicated to the imperial women of my own family: Rosemary, <br/>Sarah, Rochelle, Áine, Daniela, Nell and Willow-Rose, and my <br/>former students who inspired this book</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?49e35172